import React from "react";
import styled from "styled-components";

const Svg = styled.svg`
  display: block;
  line-height: 1;
`;

export const EzTraderIcon = () => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 25.8 25.7"
      xmlSpace="preserve"
      fill="#FFD503"
    >
      <g>
        <polygon
          points="25.6,12.5 24.3,11.2 14.5,1.5 13,0 11.5,1.5 8.5,4.5 7.6,5.4 8.9,6.7 9.4,6.7 12.3,6.7 10.9,5.2 
		11.5,4.5 13,3 22.7,12.6 21.9,13.4 20.6,14.7 12.8,14.7 11.4,13.2 8.4,13.2 9.8,14.7 11.9,16.8 13.2,16.8 21.5,16.8 22.8,15.5 
		22.8,15.5 23.6,14.7 25,13.3 25.8,12.6"
        />
        <polygon
          points="16.8,19 16.3,19 13.5,19 14.8,20.5 14.3,21.1 12.8,22.7 3,13 5.1,10.9 5.3,10.8 13,10.8 14.5,12.2 
		17.5,12.2 16.1,10.8 14,8.7 12.8,8.7 4.3,8.7 4.3,8.8 2.3,10.9 2.1,11 0,13 0.1,13.1 1.5,14.5 11.3,24.2 12.8,25.7 14.3,24.2 
		17.3,21.1 18.1,20.2"
        />
      </g>
    </Svg>
  );
};

export const EzTraderText = () => {
  return (
    <Svg
      width="100"
      height="30"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 92.6 25.7"
      xmlSpace="preserve"
      fill="#ffffff"
    >
      <g>
        <path
          fill="#FFD503"
          d="M0.1,19.5V6.2H9v2.5H3v2.6h5.3v2.4H3v3.2h6.4v2.5H0.1V19.5z"
        />
        <path
          fill="#FFD503"
          d="M21.3,8.3c-0.4,0.4-0.9,1-1.5,1.6c-0.6,0.7-1.1,1.4-1.7,2.2c-0.6,0.8-1.2,1.6-1.8,2.4
		c-0.6,0.8-1.1,1.6-1.6,2.4h6.8v2.5H11v-1.8c0.4-0.6,0.8-1.4,1.3-2.2s1.1-1.6,1.6-2.4c0.6-0.8,1.1-1.6,1.7-2.4
		c0.6-0.8,1.1-1.4,1.6-2h-5.9V6.2h9.9v2.1H21.3z"
        />
        <path d="M32.3,6.2v1.1H28v12.1h-1.3V7.3h-4.2V6.2H32.3z" />
        <path
          d="M43.2,10.2c0,1-0.3,1.8-0.8,2.4s-1.2,1-2.1,1.2c0.2,0.3,0.5,0.6,0.8,1s0.7,0.9,1,1.4c0.3,0.5,0.7,1.1,1,1.6
		c0.3,0.6,0.6,1.1,0.8,1.6h-1.4c-0.3-0.5-0.6-1-0.9-1.5s-0.6-1-1-1.5c-0.3-0.5-0.6-0.9-0.9-1.3c-0.3-0.4-0.6-0.8-0.8-1.1
		c-0.4,0-0.8,0.1-1.2,0.1h-2.1v5.4h-1.3v-13c0.5-0.1,1-0.2,1.6-0.3c0.6-0.1,1.2-0.1,1.7-0.1c1.8,0,3.2,0.3,4.1,1
		C42.7,7.8,43.2,8.8,43.2,10.2z M37.8,7.2c-0.5,0-0.9,0-1.3,0s-0.7,0.1-0.9,0.1V13h1.8c0.6,0,1.2,0,1.7-0.1s1-0.2,1.4-0.4
		s0.7-0.5,0.9-0.9c0.2-0.4,0.3-0.9,0.3-1.5S41.6,9,41.3,8.6c-0.2-0.4-0.5-0.7-0.9-0.9c-0.4-0.2-0.8-0.4-1.3-0.5
		C38.8,7.3,38.3,7.2,37.8,7.2z"
        />
        <path
          d="M55.6,19.5c-0.3-0.7-0.5-1.3-0.7-1.9s-0.4-1.2-0.6-1.8h-6.5c-0.2,0.6-0.4,1.2-0.6,1.8s-0.4,1.2-0.7,1.9h-1.4
		c0.5-1.4,1-2.7,1.4-3.9s0.9-2.3,1.3-3.4s0.9-2.1,1.3-3.1s0.9-2,1.3-2.9h1.1c0.5,1,0.9,2,1.3,2.9c0.4,1,0.8,2,1.3,3.1
		c0.4,1.1,0.9,2.2,1.3,3.4s0.9,2.5,1.5,3.9H55.6z M50.9,7.7C50.4,8.8,50,9.9,49.5,11s-0.9,2.4-1.4,3.7h5.7c-0.5-1.3-1-2.5-1.4-3.7
		C51.9,9.9,51.4,8.8,50.9,7.7z"
        />
        <path
          d="M69.3,12.8c0,1.1-0.2,2.1-0.5,3c-0.4,0.8-0.9,1.5-1.5,2.1s-1.4,1-2.3,1.3s-1.9,0.4-2.9,0.4
		c-0.5,0-1.1,0-1.7-0.1s-1.1-0.1-1.5-0.3V6.5c0.4-0.1,1-0.2,1.5-0.3c0.6-0.1,1.1-0.1,1.7-0.1c1.1,0,2.1,0.1,2.9,0.4
		c0.9,0.3,1.7,0.7,2.3,1.3c0.6,0.6,1.1,1.3,1.5,2.1C69.3,10.7,69.3,11.7,69.3,12.8z M60.2,18.3c0.1,0,0.3,0,0.6,0.1
		c0.3,0,0.8,0.1,1.5,0.1c1,0,1.8-0.1,2.5-0.4s1.3-0.6,1.8-1.1s0.8-1.1,1.1-1.8c0.2-0.7,0.4-1.5,0.4-2.3c0-0.9-0.1-1.6-0.4-2.3
		c-0.2-0.7-0.6-1.3-1.1-1.8s-1.1-0.9-1.8-1.1c-0.7-0.3-1.5-0.5-2.5-0.5c-0.7,0-1.2,0-1.5,0.1c-0.3,0-0.5,0.1-0.6,0.1V18.3z"
        />
        <path d="M72.3,19.5V6.2h7.6v1.1h-6.3v4.6h5.7V13h-5.7v5.3h6.8v1.1h-8.1V19.5z" />
        <path
          d="M91.8,10.2c0,1-0.3,1.8-0.8,2.4s-1.2,1-2.1,1.2c0.2,0.3,0.5,0.6,0.8,1s0.7,0.9,1,1.4c0.3,0.5,0.7,1.1,1,1.6
		c0.3,0.6,0.6,1.1,0.8,1.6h-1.4c-0.3-0.5-0.6-1-0.9-1.5s-0.6-1-1-1.5c-0.3-0.5-0.6-0.9-0.9-1.3c-0.3-0.4-0.6-0.8-0.8-1.1
		c-0.4,0-0.8,0.1-1.2,0.1h-2v5.4h-1.3v-13c0.5-0.1,1-0.2,1.6-0.3c0.6-0.1,1.2-0.1,1.7-0.1c1.8,0,3.2,0.3,4.1,1
		C91.3,7.8,91.8,8.8,91.8,10.2z M86.3,7.2c-0.5,0-0.9,0-1.3,0s-0.7,0.1-0.9,0.1V13h1.8c0.6,0,1.2,0,1.7-0.1s1-0.2,1.4-0.4
		s0.7-0.5,0.9-0.9c0.2-0.4,0.3-0.9,0.3-1.5S90.2,9,89.9,8.6c-0.2-0.4-0.5-0.7-0.9-0.9c-0.4-0.2-0.8-0.4-1.3-0.5
		C87.3,7.3,86.8,7.2,86.3,7.2z"
        />
      </g>
    </Svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/Icons/Index/EzTrader.js